import { TRANS_WEBP_STR } from '@commonPackage/components';

const SupportsList = [
  {
    title: '高标准的激励政策',
    desc: '针对伙伴资源及业务类型不同，制定更灵活的商务政策，让伙伴收益最大化',
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220531/l3tsy620_icon5.png',
  },
  {
    title: '更有力的市场资源支持',
    desc: '多项营销政策支持与商务支持，丰厚利润',
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220531/l3tsy61z_icon4.png',
  },
  {
    title: '完善的客户保护体系',
    desc: '通过完善的客户报备机制，保护合作伙伴利益',
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220531/l3tsx0qy_icon1.png',
  },
  // {
  //   title: '便捷的成本核算机制',
  //   desc: '以成本的角度核算价格，让合作伙伴利益最大化',
  //   icon: 'https://static.fuxi.netease.com/yaotai/portal/20220531/l3tsy621_icon6.png',
  // },
  {
    title: '专业的赋能培训',
    desc: '提供专业的产品及业务培训，全面提升伙伴的业务能力和竞争力',
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220531/l3tsx0qz_icon2.png',
  },
  // {
  //   title: '网易技术和品牌背书',
  //   desc: '业内领先的产品技术，集成网易各类资源，为伙伴带来更强的技术竞争力',
  //   icon: 'https://static.fuxi.netease.com/yaotai/portal/20220531/l3tsy61y_icon3.png',
  // },
];

const DistributorSystems = [
  {
    title: '战略级伙伴',
    desc: [
      '推广及销售网易瑶台产品及服务，拥有客户资源和销售能力',
      '拥有活动策划能力，有着丰富的活动策划创意和视觉表现能力',
      '拥有模型制作能力，能将创意和视觉完美的表现',
    ],
    bg: 'https://static.fuxi.netease.com/yaotai/portal/20220616/l4gmrjs2_b3.png',
  },
  {
    title: '领先级伙伴',
    desc: [
      '推广及销售网易瑶台产品及服务，拥有客户资源和销售能力',
      '拥有活动策划能力，有着丰富的活动策划创意和视觉表现能力',
    ],
    bg: 'https://static.fuxi.netease.com/yaotai/portal/20220616/l4gmrjry_b1.png',
  },
  {
    title: '优选级伙伴',
    desc: ['推广及销售网易瑶台产品及服务，拥有客户资源和销售能力'],
    bg: 'https://static.fuxi.netease.com/yaotai/portal/20220616/l4gmrjrz_b2.png',
  },
];

const DistributorSystemsForMobile = [
  {
    title: '战略级伙伴',
    desc: [
      '推广及销售网易瑶台产品及服务，拥有客户资源和销售能力',
      '拥有活动策划能力，有着丰富的活动策划创意和视觉表现能力',
      '拥有模型制作能力，能将创意和视觉完美的表现',
    ],
    bg: `https://static.fuxi.netease.com/yaotai/portal/20220616/l4gmrjs2_b3.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '领先级伙伴',
    desc: [
      '推广及销售网易瑶台产品及服务，拥有客户资源和销售能力',
      '拥有活动策划能力，有着丰富的活动策划创意和视觉表现能力',
    ],
    bg: `https://static.fuxi.netease.com/yaotai/portal/20220616/l4gmrjry_b1.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '优选级伙伴',
    desc: ['推广及销售网易瑶台产品及服务，拥有客户资源和销售能力'],
    bg: `https://static.fuxi.netease.com/yaotai/portal/20220616/l4gmrjrz_b2.png?${TRANS_WEBP_STR}`,
  },
];

const CaseList = [
  {
    title: '2022 中国国际大数据产业博览会',
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    desc: '2022 数博会“元宇宙”论坛成功举办。论坛以“突破虚实 超越想象--共享元宇宙发展新机遇”为主题，汇聚业内专家及企业高层，就元宇宙产业发展趋势、元宇宙概念的认知和前沿新技术的突破、元宇宙未来应用场景等话题展开深入探讨。',
    poster: 'https://static.fuxi.netease.com/yaotai/portal/20220622/l4p0vmlk_WechatIMG16.png',
  },
  {
    title: '2022 阿里云视觉计算私享会',
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    desc: '会议在网易瑶台中举办，邀请了数字王国虚谷未来、如视、平行云、AI Talk 等多个行业的企业高管从不同的专业角度进行了分享，讲师及嘉宾可以控制专属人物在虚拟的会议场景内进行互动，在拟真场景中面对面畅聊互动，全新的参会体验也让本次参会的嘉宾们眼前一亮。',
    poster: 'https://static.fuxi.netease.com/yaotai/portal/20220622/l4p0vmlg_1652788136709_b7d99476.jpeg',
  },
  {
    title: '中欧校友（苏州）总部大厦产业规划发布会',
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    desc: '中欧校友（苏州）总部大厦通过网易瑶台正式发布产业规划，300 多名嘉宾通过虚拟现实技术，在由科技链接的现实和虚拟世界“元宇宙”中共同展望这一产业基地的发展和阳澄湖半岛度假区智能融通经济的未来。',
    poster: 'https://static.fuxi.netease.com/yaotai/portal/20220622/l4p0vmle_6401.png',
  },
  {
    title: '2022【生态守护映像】沉浸式公益生态摄影展',
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    desc: '网易瑶台携手政协称多县委举办 2022【生态守护映像】沉浸式公益生态摄影展，发挥网易瑶台的社会价值，用“科技 + 公益”的形式为保护野生动植物点燃一份微光。',
    poster: 'https://static.fuxi.netease.com/yaotai/portal/20220622/l4p0vmlc_640.png',
  },
  {
    title: '网易星球举办 2022 首届元宇宙艺术展活动',
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    desc: '元宇宙艺术展以“Power of future” (未来之力) 为主题，将数字艺术作品聚合入虚拟空间，活 动现场气氛热烈，众多参展人士通过虚拟分身，在元宇宙空间中品味艺术，重新解构当下与未来的连接，重新定义“未来艺术” 。',
    poster: 'https://static.fuxi.netease.com/yaotai/portal/20220622/l4p0vmlh_image2022-6-17_12-10-14.png',
  },
];

const PartnersList = [
  [
    {
      title: '网易云信',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7ps8mh5_008393.png',
    },
    {
      title: '华为云',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7ps8jdn_004379.png',
    },
    {
      title: '华集',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7ps8pld_012433.png',
    },
  ],
  [
    {
      title: '数智',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7ps8spk_016472.png',
    },
    {
      title: 'popify',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7ps8xzs_023320.png',
    },
    {
      title: '睿森智联',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7pyegmf_358438.png',
    },
  ],
  [
    {
      title: '威迅通',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7ps8vf8_019988.png',
    },
    {
      title: '伍方',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7pvik2l_510684.png',
    },
    {
      title: '微吼',
      icon: 'https://static.fuxi.netease.com/yaotai/portal/20220906/l7ps90hc_026544.png',
    },
  ],
];

export { SupportsList, DistributorSystems, DistributorSystemsForMobile, CaseList, PartnersList };
